import { NgForOf } from "@angular/common";
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Router } from "@angular/router";
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from "app/core/auth/auth.service";
import { CompanyUserRole } from 'app/core/company/company-user-role';
import { CurrentUserService } from 'app/core/user/current-user.service';
import { User } from 'app/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-change-company',
    templateUrl: './change-company.component.html',
    styleUrls: ['./change-company.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        TranslocoModule,
        NgForOf
    ]
})
export class ChangeCompanyComponent {

    composeForm: UntypedFormGroup;

    public user: User;
    private unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _router: Router,
        private matDialogRef: MatDialogRef<ChangeCompanyComponent>,
        private changeDetectorRef: ChangeDetectorRef,
        private userService: CurrentUserService,
        private authService: AuthService,
        private formBuilder: UntypedFormBuilder,
    ) {
    }

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Create the form
        this.composeForm = this.formBuilder.group({
            company: [''],
        });

        // Subscribe to user changes
        this.userService.user$
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((user: User) =>
            {
                this.user = user;

                this.composeForm.setValue({
                    company: this.user.companyId
                })

                // Mark for check
                this.changeDetectorRef.markForCheck();
            });
    }

    /**
     * Change active company and close the dialog.
     */
    changeCompany(): void
    {
        this.userService.changeCompany(this.composeForm.get('company').value).subscribe({
            next: (result) => {
                this.authService.accessToken = result.token;
                this.authService.refreshToken = result.refreshToken;

                this.userService.get().subscribe();
            },
            complete: () => {
                this._router.navigate(['/overview']);
                this.matDialogRef.close();
            }
        });
    }

    /**
     * Close the dialog without changing the active company.
     */
    cancel(): void
    {
        this.matDialogRef.close();
    }

    /**
     *
     */
    getUserCompanies()
    {
        return this.user.companies
    }
}
